import React from 'react';

type GfLoaderProps = {
  /** The text to show in the loading spinner */
  text?: string;
  /** Whether to show the loader inline */
  inline?: boolean;
};

/** A loading spinner. */
export default function GfLoader({ text, inline }: GfLoaderProps) {
  if (inline) {
    return <div className="ui active centered inline loader">{text}</div>;
  }

  return (
    <div className="ui active inverted dimmer">
      <div className="ui loader">
        <div className="loader-text">{text}</div>
      </div>
    </div>
  );
}
